<script setup lang="ts">
/**
 * BaseAccordion — landing.css 의 .faq(<details>) 원자(네이티브 details 유지).
 *  summary 에 Q 마커(골드 칩) + 질문 + chevron(open 시 180° 회전).
 *  답변은 기본 slot 으로 받는다(b 강조는 slot 내용에 위임).
 * 색은 토큰 경유. open prop 으로 초기 펼침 제어.
 */
import { ChevronDown } from 'lucide-vue-next';

interface Props {
  /** 질문 텍스트(summary) */
  question: string;
  /** 초기 펼침 여부 */
  open?: boolean;
}

withDefaults(defineProps<Props>(), {
  open: false,
});
</script>

<template>
  <details
    class="fo-faq mb-3 overflow-hidden rounded-xl border border-line bg-white shadow-sm"
    :open="open"
  >
    <summary
      class="flex cursor-pointer list-none items-center justify-between gap-4 px-6 py-[21px] text-[16px] font-bold tracking-[-0.02em] text-brand"
    >
      <span class="flex items-center gap-[13px]">
        <span
          class="flex h-6 w-6 flex-none items-center justify-center rounded-md bg-accent-soft text-[13px] font-extrabold text-accent-deep"
          aria-hidden="true"
          >Q</span
        >
        <span>{{ question }}</span>
      </span>
      <ChevronDown class="fo-faq-chev h-5 w-5 flex-none text-muted transition-transform" />
    </summary>
    <div class="px-6 pb-[22px] pl-[61px] text-[14.5px] leading-[1.74] tracking-[-0.01em] text-body">
      <slot />
    </div>
  </details>
</template>

<style scoped>
/* summary 의 네이티브 디스클로저 마커 제거 */
.fo-faq summary::-webkit-details-marker {
  display: none;
}

/* .faq[open] summary .chev{transform:rotate(180deg)} 재현 */
.fo-faq[open] .fo-faq-chev {
  transform: rotate(180deg);
}
</style>
